import { FilmComponent } from "../FilmComponent/FilmComponent"
import { GalleryComponent2 } from "../Gallery/GalleryComponent2"
import { april2025Photos } from "../Gallery/LabPhotos/april2025/april2025Photos"
import video from "../../assets/labPhotos/april2025/video.mp4"

import "./LabText.scss"

export const April2025 = () => {
	return (
		<div className='april2025'>
			<h2 className='LabTitle'>marzec - kwiecień</h2>
			<p className='LabText2'>
				Korzystanie ze sprzętu, który pozyskaliśmy w ramach Laboratorium
				Przyszłości umożliwiły poszerzenie naszych pomocy dydaktycznych. Dzięki
				posiadaniu drukarki 3D uczniowie projektowali i drukowali pomoce na
				matematykę, mamy kolekcję brył: prostopadłościany, sześciany,
				ostrosłupy, korzystaliśmy także z długopisów 3D przy pomocy których
				uczniowie wykonywali dekoracje wielkanocne.
			</p>
			<p className='LabText2'>
				Pierwszy dzień wiosny uczniowie klasy szóstej uczcili organizując
				konkurs na najpiękniejsze zdjęcie pierwszych wiosennych kwiatów.
			</p>
			<p className='LabText2'>
				Uczniowie klasy szóstej ćwiczyli kręcenie filmików, na lekcji języka
				angielskiego. Uczniowie klasy ósmej nagrywali rozmówki w języku
				niemieckim.
			</p>
			<p className='LabText2'>
				Klocki Lego wykorzystywano na rewalidacji w klasach młodszych, uczniowie
				budowali budowle posługując się instrukcją, a także według własnego
				pomysłu. Z dużym zaangażowaniem uczniowie dokumentują wszelkie imprezy i
				szkolne i klasowe.
			</p>
			<GalleryComponent2
				carouselId='april2025Photos'
				images={april2025Photos}
			/>
			<FilmComponent videoPath={video} />
		</div>
	)
}
